// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"58fc8873","977":"4c434bdf"}[chunkId] + ".chunk.js";
};